import React from 'react';

export const CircleIconPost = (props: { color?: string }): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54">
      <g fill={props.color ?? 'currentColor'} fillRule="evenodd">
        <path
          stroke={props.color ?? 'currentColor'}
          strokeLinecap="round"
          strokeWidth="2.51"
          d="m20.25 16.5-1.68-3.35M33 16.5l3-3"
        />
        <path
          stroke={props.color ?? 'currentColor'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2.51"
          d="M27 9v6"
        />
        <path
          fillRule="nonzero"
          d="M27 0a27 27 0 1 1 0 54 27 27 0 0 1 0-54m0 4.5a22.5 22.5 0 1 0 0 45 22.5 22.5 0 0 0 0-45"
        />
        <path d="M39 20.25a3 3 0 0 1 3 3V46.5a3 3 0 0 1-3 3H15a3 3 0 0 1-3-3V23.25a3 3 0 0 1 3-3zm-1.87 21.06H15.36c-.2 0-.37.17-.37.37v1.57c0 .21.17.38.38.38h21.74c.21 0 .38-.17.38-.38v-1.57c0-.2-.17-.37-.37-.37m-1.74-4.1H15.38c-.21 0-.38.18-.38.38v1.57c0 .21.17.38.38.38h20.01c.21 0 .38-.17.38-.38V37.6c0-.2-.17-.37-.38-.37M23.52 24.76h-8.04a.5.5 0 0 0-.48.48v2.11c0 .27.22.49.48.49h2.2a.5.5 0 0 1 .48.5l-.29 4.9a.5.5 0 0 0 .48.52h2.23a.5.5 0 0 0 .48-.52l-.31-4.89a.5.5 0 0 1 .45-.51h2.32c.26 0 .48-.22.48-.49v-2.1a.5.5 0 0 0-.48-.49m10.73 5.5h-6.5a.75.75 0 0 0-.75.74V33c0 .41.34.75.75.75h6.5c.41 0 .75-.34.75-.75v-2a.75.75 0 0 0-.75-.76m4-5.5h-10.5a.75.75 0 0 0-.75.75v2c0 .42.34.76.75.76h10.5c.41 0 .75-.34.75-.75V25.5a.75.75 0 0 0-.75-.75" />
      </g>
    </svg>
  );
};
